import Vue from 'vue';
import vueDebounce from 'vue-debounce';

// Listening to multiple events
Vue.use(vueDebounce, {
  listenTo: ['input', 'keyup'],
  lock: true,
});
